import axios from 'axios';
import download from '../../common/helpers/download';
import { noContentCode } from '../../constant';

export const url = `/api/v1/reports/tailgate`;

const generateFileName = (cargoType, startDate, endDate) => `Tailgate-${[cargoType, startDate, endDate].filter(Boolean).join('-')}.xlsx`;

export const getReport = async (siteId, startDate, endDate, cargoType) => {
  const response = await axios.get(url, {
    params: {
      siteId,
      cargoType,
      startDate,
      endDate,
    },
    responseType: 'blob',
  });

  if (response.status === noContentCode) {
    return undefined;
  }

  download(response.data, generateFileName(cargoType, startDate, endDate));
  return response.data;
};

export const getTailgateReportSites = (cargoType) => {
  return axios.get(`${url}/sites`, {
    params: {
      cargoType,
    },
  });
};
